import { checkRedirect } from '@UTILs/redirect';
import NEW_API_ENDPOINT from '../CONSTANTs/new_api_endpoint';

const STATIC_PAYLOAD = {
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'same-origin',
  redirect: 'follow',
  referrerPolicy: 'no-referrer',
  method: 'POST'
};

const AUTH = {
  get Authorization() {
    return `Bearer ${sessionStorage.getItem('accessToken')}`;
  }
};

const _HEADERS = (headers) => {
  const _headers = {
    'Content-Type': 'application/json',
    ...headers
  };
  return () => _headers;
};

async function silentRefresh() {
  try {
    const res = await fetch(`${NEW_API_ENDPOINT}/api/refresh`, {
      method: "POST",
      credentials: "include", // sends HttpOnly refresh cookie
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!res.ok) throw new Error("Refresh failed");

    const data = await res.json();

    // Store new access token
    sessionStorage.setItem("accessToken", data.accessToken);

    return data.accessToken;
  } catch (err) {
    console.error("Silent refresh failed", err);

    // Hard logout
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/";

    throw err;

  }
}


// ----------------------------------
// 🔒 Global refresh lock + queue
// ----------------------------------
let refreshPromise = null;

async function handleRefresh() {
  if (refreshPromise) {
    return refreshPromise; // wait existing refresh
  }

  // Assign immediately (no race window)
  refreshPromise = (async () => {
    try {
      const token = await silentRefresh();
      return token;
    } catch (err) {
      throw err;
    } finally {
      refreshPromise = null; // reset after completion
    }
  })();

  return refreshPromise;
}


export async function postData(url = '', data = {}, params = {}, retry = true) {
  const { isWithOutAuth, isForm, headers } = params;

  let HEADERS = _HEADERS(headers)();

  const payload = {
    ...STATIC_PAYLOAD,
    credentials: "include",
    body: isForm ? data : JSON.stringify(data)
  };

  if (!isWithOutAuth) {
    HEADERS = _HEADERS(AUTH)();
  }

  if (!isForm) {
    payload.headers = HEADERS;
  }

  let response = await fetch(url, payload);

  // --------------------------------------------------
  // 🔁 Silent refresh on 401 (LOCKED)
  // --------------------------------------------------
  if (response.status === 401 && !isWithOutAuth && retry) {
    try {
      const newAccessToken = await handleRefresh();

      // Rebuild headers safely
      payload.headers = {
        ...(payload.headers || {}),
        Authorization: `Bearer ${newAccessToken}`,
        "Content-Type": "application/json"
      };

      response = await fetch(url, payload);

    } catch (err) {
      console.error("Refresh failed → logout");
      window.location.href = "/login";
      throw err;
    }
  }

  // --------------------------------------------------
  // ✅ Success handling
  // --------------------------------------------------
  if (response.ok || response.status === 302) {
    return response.status === 204
      ? response.text()
      : response.json();
  }

  const errorData = await response.json();
  throw new Error(errorData.message);
}

export async function getData(url = '', retry = true) {
  let response = await fetch(url, {
    headers: _HEADERS(AUTH)(),
    credentials: "include"
  });

  if (response.status === 401 && retry) {
    try {
      const newAccessToken = await handleRefresh();

      response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${newAccessToken}`,
          "Content-Type": "application/json"
        },
        credentials: "include"
      });

    } catch (err) {
      console.error("Refresh failed → logout");
      window.location.href = "/login";
      throw err;
    }
  }

  if (
    response.ok ||
    response.status === 302 ||
    response.status === 400 ||
    response.status === 500
  ) {
    if (response.status !== 204) {
      return response.json();
    }
    return {};
  }

  const errorData = await response.json();
  throw new Error(errorData.message);
}
